import { ReactNode } from 'react';
import {
  Accordion as ReactAccordion,
  AccordionItem,
  AccordionItemButton,
  AccordionItemHeading,
  AccordionItemPanel,
  AccordionItemState,
} from 'react-accessible-accordion';
import ArrowDownSLineIcon from 'remixicon-react/ArrowDownSLineIcon';
import ArrowUpSLineIcon from 'remixicon-react/ArrowUpSLineIcon';
import QuestionMarkIcon from 'remixicon-react/QuestionMarkIcon';
import slugify from '../slugify';

export const Accordion = ({
  list,
  showIcon = true,
}: {
  list: { question: string; answer: string | ReactNode }[];
  showIcon?: boolean;
}) => {
  return (
    <ReactAccordion allowZeroExpanded={true} preExpanded={list.map((i) => slugify(i.question))}>
      {list.map((item, idx) => {
        return (
          <AccordionItem key={idx} className="my-2 " uuid={slugify(item.question)}>
            <AccordionItemState>
              {({ expanded }) => {
                return (
                  <>
                    <AccordionItemHeading>
                      <AccordionItemButton>
                        <div
                          className={`bg-surface-grey border-grey-200 flex items-center justify-between border px-5 py-4 ${
                            expanded ? 'rounded-t-medium ' : 'rounded-medium'
                          } `}
                        >
                          {showIcon && (
                            <div className="rounded-full bg-blue-100 p-1">
                              <div className="rounded-full bg-blue-200 p-1">
                                <QuestionMarkIcon className="text-primary  " size={16} />
                              </div>
                            </div>
                          )}
                          <p className={`ml-3 flex-1 font-bold `}>{item.question}</p>
                          {expanded ? <ArrowUpSLineIcon /> : <ArrowDownSLineIcon />}
                        </div>
                      </AccordionItemButton>
                    </AccordionItemHeading>
                    <AccordionItemPanel
                      className={`border-grey-200 rounded-b-medium border border-t-0 p-4 ${expanded ? '' : ''}`}
                    >
                      {typeof item.answer === 'string' ? (
                        <div dangerouslySetInnerHTML={{ __html: item.answer }} />
                      ) : (
                        item.answer
                      )}
                    </AccordionItemPanel>
                  </>
                );
              }}
            </AccordionItemState>
          </AccordionItem>
        );
      })}
    </ReactAccordion>
  );
};
